import { PacksClient } from '../types'
import { JoinPackResponse } from '../types/PacksClient'

export const joinPack = (base: PacksClient) => (id: string, key?: string, key_id?: string) =>
  base.requester.post<JoinPackResponse>(`/${id}/join`, { key, key_id })
